import React, { useState } from 'react'
import { Box, Button, Flex, Table, Text } from '@workwhile/ui'
import { Plus } from 'lucide-react'
import { AccordionCard } from 'components/AccordionCard'
import { TableEmptyState } from 'components/Table/TableEmptyState'
import { useSelectedColumns } from './ColumnsFilter/useSelectedColumns'
import { usePaginationQueryState } from 'lib/nuqs/usePaginationQueryState'
import { usePositionDetailContextValue } from '../context/PositionDetailProvider'
import { AddRequirementModal } from './AddRequirementModal'

const RequirementsTable = () => {
  const {
    state: { requirements },
  } = usePositionDetailContextValue()
  const [pagination, setPagination] = usePaginationQueryState({
    defaultPageSize: 10,
    urlKeys: {
      pageIndex: 'requirements-page',
      pageSize: 'requirements-page-size',
    },
  })

  const columns = useSelectedColumns()

  if (requirements.length === 0) {
    return (
      <TableEmptyState
        isFetching={false}
        emptyMessage="No requirements found"
      />
    )
  }

  return (
    <Box>
      <Table
        columns={columns}
        data={requirements}
        clientPagination={{ state: pagination, setState: setPagination }}
      />
    </Box>
  )
}

export const Requirements = () => {
  const [isAddModalOpen, setIsAddModalOpen] = useState(false)

  return (
    <>
      <AccordionCard
        title={
          <Flex justifyContent="space-between" alignItems="center" gap={2}>
            <Text fontSize={2} color="lightText">
              Requirements
            </Text>
            <Button
              kind="small"
              variant="primary"
              onClick={() => setIsAddModalOpen(true)}
            >
              <Flex as="span" alignItems="center" style={{ gap: 6 }}>
                <Plus size={14} />
                Add
              </Flex>
            </Button>
          </Flex>
        }
        size="large"
        contentWrapperProps={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <RequirementsTable />
      </AccordionCard>
      <AddRequirementModal
        open={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
      />
    </>
  )
}
